import { createSlice } from "@reduxjs/toolkit";

/**
 * Auth Redux — mirrors appointo_client Redux/AuthRedux.js
 *
 * Modernized: createSlice (RTK) replaces createActions/createReducer (reduxsauce).
 * Actions that only trigger sagas are no-ops in the reducer.
 * Components use the callback pattern:
 *   dispatch(loginRequest({ params, callback }))
 */

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
  user: null,
  token: null,
  isAuthenticated: false,
};

/* ------------- Slice ------------- */
const authSlice = createSlice({
  name: "auth",
  initialState: INITIAL_STATE,
  reducers: {
    // Saga-only actions (no state change)
    startupRequest: () => {},
    loginRequest: () => {},
    signupRequest: () => {},
    meRequest: () => {},
    logoutRequest: () => {},

    // State mutations (dispatched by sagas)
    loginSuccess(state, action) {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
    },
  },
});

/* ------------- Action Creators (default export) ------------- */
export default authSlice.actions;

/* ------------- Named Action Exports ------------- */
export const {
  startupRequest,
  loginRequest,
  signupRequest,
  meRequest,
  logoutRequest,
  loginSuccess,
  logout,
} = authSlice.actions;

/* ------------- Reducer ------------- */
export const { reducer } = authSlice;

/* ------------- Selectors ------------- */
export const selectUser = (state) => state.auth.user;
export const selectToken = (state) => state.auth.token;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
